module.exports = __webpack_public_path__ + "img/thumbnail_Moose_f_normal.08a0b669.png";